(function () {
  function initialise(root) {
    if (root.getAttribute('data-evvo-pincode-ready') === 'true') return;

    var input = root.querySelector('[data-evvo-pincode-input]');
    var button = root.querySelector('[data-evvo-pincode-submit]');
    var result = root.querySelector('[data-evvo-pincode-result]');
    var minDays = root.getAttribute('data-min-days') || '3';
    var maxDays = root.getAttribute('data-max-days') || '5';

    if (!input || !button || !result) return;
    root.setAttribute('data-evvo-pincode-ready', 'true');

    function isValid() {
      return /^[0-9]{6}$/.test(input.value.trim());
    }

    function updateButton() {
      button.disabled = !isValid();
    }

    function clearResult() {
      root.classList.remove('has-result');
      result.hidden = true;
      result.className = 'product-pincode-checker__result';
      result.replaceChildren();
    }

    function showError(message) {
      root.classList.add('has-result');
      result.hidden = false;
      result.className = 'product-pincode-checker__result is-error';
      result.textContent = message;
    }

    function showSuccess(pincode, locationName) {
      var message = document.createElement('span');
      var strong = document.createElement('strong');
      var change = document.createElement('button');

      strong.textContent = 'Delivery in ' + minDays + '–' + maxDays + ' days';
      message.appendChild(strong);
      message.appendChild(document.createTextNode(' to ' + locationName + ' ' + pincode));
      change.type = 'button';
      change.textContent = 'Change';
      change.addEventListener('click', function () {
        input.value = '';
        clearResult();
        updateButton();
        input.focus();
      });

      result.replaceChildren(message, change);
      result.className = 'product-pincode-checker__result is-success';
      result.hidden = false;
      root.classList.add('has-result');
    }

    function checkPincode() {
      var pincode = input.value.trim();
      if (!isValid()) return;

      button.disabled = true;
      button.textContent = 'Checking';

      fetch('https://api.postalpincode.in/pincode/' + pincode)
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function (data) {
          var record = data && data[0];
          var postOffice = record && record.PostOffice && record.PostOffice[0];

          if (record && record.Status === 'Success' && postOffice) {
            showSuccess(pincode, postOffice.District);
          } else {
            showError('Enter a valid serviceable pincode.');
          }
        })
        .catch(function () {
          showError('We could not verify this pincode. Please try again.');
        })
        .finally(function () {
          button.textContent = 'Check';
          updateButton();
        });
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      clearResult();
      updateButton();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && isValid()) {
        event.preventDefault();
        checkPincode();
      }
    });

    button.addEventListener('click', checkPincode);
    updateButton();
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll('[data-evvo-pincode-checker]').forEach(initialise);
  }

  initialiseAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
